(function () {
  'use strict';

  var mobileQuery = window.matchMedia('(max-width: 767px)');

  function setupGallery(gallery) {
    if (!gallery || gallery.dataset.mobileGalleryReady === 'true' || gallery.classList.contains('ever-product-gallery--upload')) return;

    gallery.dataset.mobileGalleryReady = 'true';
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('.ever-product-media'));
    var dots = gallery.nextElementSibling && gallery.nextElementSibling.matches('[data-mobile-gallery-dots]')
      ? gallery.nextElementSibling
      : null;
    var dotButtons = dots ? Array.prototype.slice.call(dots.querySelectorAll('[data-mobile-gallery-dot]')) : [];
    var frame = 0;

    function currentSlide() {
      var galleryRect = gallery.getBoundingClientRect();
      var galleryCenter = galleryRect.left + (galleryRect.width / 2);
      return slides.reduce(function (closest, slide, index) {
        var slideRect = slide.getBoundingClientRect();
        var slideCenter = slideRect.left + (slideRect.width / 2);
        var distance = Math.abs(slideCenter - galleryCenter);
        return !closest || distance < closest.distance ? { slide: slide, index: index, distance: distance } : closest;
      }, null);
    }

    function setActiveDot(index) {
      dotButtons.forEach(function (dot, dotIndex) {
        var active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
        dot.tabIndex = active ? 0 : -1;
      });
    }

    function setCurrentHeight() {
      frame = 0;

      if (!mobileQuery.matches) {
        gallery.style.removeProperty('--ever-mobile-gallery-height');
        return;
      }

      var current = currentSlide();
      if (!current) return;

      setActiveDot(current.index);

      var image = current.slide.querySelector('img');
      var width = current.slide.clientWidth;
      var imageWidth = image && (image.naturalWidth || Number(image.getAttribute('width')));
      var imageHeight = image && (image.naturalHeight || Number(image.getAttribute('height')));
      var height = imageWidth > 0 && imageHeight > 0 ? width * imageHeight / imageWidth : current.slide.scrollHeight;

      if (height > 0) gallery.style.setProperty('--ever-mobile-gallery-height', Math.round(height) + 'px');
    }

    function requestHeightUpdate() {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(setCurrentHeight);
    }

    gallery.addEventListener('scroll', requestHeightUpdate, { passive: true });
    dotButtons.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = Number(dot.dataset.galleryIndex);
        var slide = slides[index];
        if (!slide) return;

        var firstSlide = slides[0];
        gallery.scrollTo({
          left: slide.offsetLeft - firstSlide.offsetLeft,
          behavior: 'smooth'
        });
        setActiveDot(index);
      });
    });
    slides.forEach(function (slide) {
      var image = slide.querySelector('img');
      if (image && !image.complete) image.addEventListener('load', requestHeightUpdate, { once: true });
    });

    if ('ResizeObserver' in window) {
      new ResizeObserver(requestHeightUpdate).observe(gallery);
    } else {
      window.addEventListener('resize', requestHeightUpdate, { passive: true });
    }

    if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', requestHeightUpdate);
    requestHeightUpdate();
  }

  function init() {
    document.querySelectorAll('[data-product-gallery]').forEach(setupGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
